export default __webpack_public_path__ + "static/media/blog-img111.539be097.jpg";